<main id="main-content" class="h-screen flex flex-col pl-10 py-4 pr-4 transition-all duration-0">
    <div class="w-full flex flex-col p-2 items-center gap-2">
        <div class="w-full flex flex-row items-center justify-between">
            <div class="w-full flex gap-2 items-center justify-start">
                <h1 class="oswald-font text-3xl uppercase">
                    SRO Training Resources
                </h1>
                <div data-popover-target="popover-bottom" data-popover-placement="bottom" type="button">
                    <lucide-icon [name]="icons.CircleHelp" [size]=24 class="text-red-500"></lucide-icon>
                </div>
                <div data-popover id="popover-bottom" role="tooltip" class="absolute z-30 invisible inline-block w-fit max-w-[600px] text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-200 rounded-md shadow-xs opacity-0">

                    <div class="px-3 py-2">
                        <p>
                            Provide an introductory statement that includes philosophy, expectations, and directives to school staff, students, and parents. Click 'Confirm' to confirm the statement if no changes are needed.
                        </p>
                    </div>
                    <div data-popper-arrow></div>
                </div>
            </div>
            <eop-assistant
                *ngIf="currentPageRoute !== 'training-exercises'"
                [sectionId]="eopSectionTypeId"
                [subSectionId]="eopSubSectionTypeId"
            ></eop-assistant>
        </div>
    </div>
    
    <!-- MAIN CONTENT -->
    <div class="p-2 w-full flex flex-col flex-grow items-start overflow-y-auto">
        <div class="relative z-10 w-full flex flex-wrap items-end justify-start gap-1">
            <button
                *ngFor="let doc of trainingDocs"
                class="min-w-32 px-3 py-2 rounded-t-lg oswald-font shadow-custom-2 text-lg text-center cursor-pointer"
                [ngClass]="{
                    'bg-white text-nside-orange-400': selectedDoc.name === doc.name,
                    'bg-gradient-to-b from-nside-gray-100 to-nside-gray-200 text-white': selectedDoc.name !== doc.name
                    }"
                (click)="$event.preventDefault(); selectDoc(doc);"
            >
                {{ doc.name }}
            </button>
        </div>
        <div
            class="w-full min-h-96 max-h-full flex flex-col items-center justify-start gap-4"
        >
            <div class="w-full bg-white rounded-md shadow-custom-2 p-6 flex flex-col flex-grow gap-4 overflow-y-auto">
                <!-- TRAINING RESOURCES -->
                <div class="w-full h-full flex flex-col items-center gap-4 overflow-y-auto">
                    <div class="w-full">
                        <p class="oswald-font text-base">
                            TRAINING:
                            <span class="inline-flex raleway-font">
                                {{ selectedDoc.title }}
                            </span>
                        </p>
                        <p class="oswald-font text-base">
                            RECOMMENDED COMPLETION:
                            <span class="inline-flex raleway-font">
                                {{ selectedDoc.recommendedCompletion }}
                            </span>
                        </p>
                        <p *ngIf="selectedDoc.mdePolicy" class="oswald-font text-base">
                            MDE POLICY:
                            <a class="inline-flex raleway-font text-blue-500 underline" [href]="selectedDoc.mdePolicy.url" target="_blank">
                                {{ selectedDoc.mdePolicy.label }}
                            </a>
                        </p>
                        <p *ngIf="selectedDoc.msStateLaw" class="oswald-font text-base">
                            MS STATE LAW:
                            <a class="inline-flex raleway-font text-blue-500 underline" [href]="selectedDoc.msStateLaw.url" target="_blank">
                                {{ selectedDoc.msStateLaw.label }}
                            </a>
                        </p>
                        <p *ngFor="let link of selectedDoc.webLinks" class="oswald-font text-base">
                            WEB LINK:
                            <a class="inline-flex raleway-font text-blue-500 underline" [href]="link.url" target="_blank">
                                {{ link.label }}
                            </a>
                        </p>
                        <p class="oswald-font text-base">
                            LOG TRAINING:
                            <button (click)="$event.preventDefault(); navigateToPage('drills-training-collaboration-reports')" class="inline-flex raleway-font text-blue-500">
                                Add Training Log
                            </button>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <prv-next-buttons></prv-next-buttons>
</main>

<introduction></introduction>

<popup-message 
    [type]="messageModal"
    [message]="popupMessage"
    (close)="resetMessageModal()"
></popup-message>

<div *ngIf="loading">
    <spinner></spinner>
</div>
